// extracted by mini-css-extract-plugin
module.exports = {"loading-error-wrapper":"loading-error-wrapper--2tz5oTAl"};